import moment from 'moment';

/**
 *
 * @param {*} date
 */
const getRemainingMonths = (date) => {
  let months = '';
  const fechaFin = moment(date);
  const currentDate = moment(new Date())
  if (fechaFin && currentDate) {
    const duration = moment.duration(fechaFin.diff(currentDate))
    months = Math.ceil(duration.asMonths());
  }

  return months;
}


/**
 * obtiene la info de los dispositivo adicional contratados
 * @param {object} myHiredProducts producto contratado
 * @returns {obj}
 */
export const getAditionalDeviceInfo = (myHiredProducts) => {
  const aditionalDevicesInfo = [];
  if (
    myHiredProducts
    && Array.isArray(myHiredProducts)
    && myHiredProducts.length > 0
  ) {
    myHiredProducts.forEach((productoContratado) => {
      if (productoContratado.productType && productoContratado.productType === 9) {
        if (productoContratado.categorias) {
          const { categorias } = productoContratado;
          if (categorias && categorias.tipoDispositivo && (categorias.tipoDispositivo.toString() === '1' || categorias.tipoDispositivo.toString() === '2')) {
            const terminalData = {
              nombre: productoContratado.name,
              fechaFinal: getRemainingMonths(productoContratado.fechaFinal),
              productId: productoContratado.poId,
              subseccion: productoContratado.subseccion,
            };
            aditionalDevicesInfo.push(terminalData)
          }
        }
      }
    });
  }
  return aditionalDevicesInfo;
}

/**
 * obtiene la info del temrinal segun el producto contratado
 * @param {object} myHiredProducts info sobre el producto contratado
 * @returns {obj}
 */
export const getDeviceInfoFromHiredProduct = (myHiredProducts) => {
  const includedlDevicesInfo = [];
  if (
    myHiredProducts
      && Array.isArray(myHiredProducts)
      && myHiredProducts.length > 0
  ) {
    const myHiredProduct = myHiredProducts[0];
    const hasMyHiredMobile = myHiredProduct.mobile !== null;
    if (hasMyHiredMobile) {
      const myHiredMobile = myHiredProduct.mobile;
      const hasMyHiredlinesMobile = myHiredMobile.linesMobile !== null;
      if (hasMyHiredlinesMobile) {
        const myHiredlinesMobile = myHiredMobile.linesMobile;
        if (Array.isArray(myHiredlinesMobile)) {
          myHiredlinesMobile.forEach((line) => {
            const hasProductosContratados = line.productosContratadosDedependientes !== null;
            if (hasProductosContratados) {
              const productosContratados = line.productosContratadosDedependientes;
              productosContratados.forEach((productoContratado) => {
                if (
                  productoContratado.productType === 9
                    && productoContratado.categorias
                    && productoContratado.categorias.tipoDispositivo
                    && (productoContratado.categorias.tipoDispositivo.toString() === '1' || productoContratado.categorias.tipoDispositivo.toString() === '2')
                ) {
                  const terminalData = {
                    nombre: productoContratado.name,
                    fechaFinal: getRemainingMonths(productoContratado.fechaFinal),
                    productId: productoContratado.poId,
                    subseccion: productoContratado.subseccion,
                  };
                  includedlDevicesInfo.push(terminalData)
                }
              });
            }
          });
        }
      }
    }
  }
  return includedlDevicesInfo;
};
